import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { connect, Dispatch } from 'react-redux';
import {
    IApplicationState, AppActionCreators, SerologyTrackingActionCreators, ISerologyTrackingListResponse, SerologyListType,
    ISerologyTrackingResponse, ISerologyLookupDataResponse
} from '@nkr/store/index';
import { IBaseResponse, IListItem, ISerologyTracking, ISerologySearchRequest } from '@nkr/models/index';
import { Actions, FilterCenterBy } from './models';
import { Button, Glyphicon } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Grid from './grid';
import Drawer from 'rc-drawer';
import ActionsDropdown from './actions-dropdown';
import View from './view';
import MediaQuery from 'react-responsive';
import Filters from './filters';
import MarkShippedBack from './mark-shipped-back';
import MarkShippedOut from './mark-shipped-out';

interface IProps {
    centerId: number,
    isAdmin: boolean,
    tab: string
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<ISerologyLookupDataResponse>,
    getByCenter: (centerId: number, serologyFilter: ISerologySearchRequest) => Promise<ISerologyTrackingListResponse>,
    markReceived: (id: number, centerId: number) => Promise<ISerologyTrackingResponse>,
    markRemoteShipped: (id: number, centerId: number, trackingNumber: string, shippedDateTime: string) => Promise<ISerologyTrackingResponse>,
    markShippedBack: (id: number, centerId: number, trackingNumber: string, shippedDateTime: string) => Promise<ISerologyTrackingResponse>,
    updateDeadline: (id: number, deadline: string) => Promise<IBaseResponse>,
    getSerologyTrackingDetails: (trackingId: number) => Promise<ISerologyTrackingResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: ISerologyTracking[],
    listType: SerologyListType,
    statusList: IListItem[],
    centerList: IListItem[],
    serologyStatus: number,
    serologyType: number,
    filterCenterBy: FilterCenterBy,
    filterCenterId: number,
    filters: ISerologySearchRequest,
    remoteShipped: {
        show: boolean,
        data: ISerologyTracking
    },
    shippedBack: {
        show: boolean,
        data: ISerologyTracking
    },
    details: {
        show: boolean,
        data: ISerologyTracking
    },
    viewSidePanel: {
        show: boolean,
        data: ISerologyTracking
    },
}

class SerologyTracking extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        listType: 0,
        statusList: [
            { id: 0, description: 'To-Do', abbreviation: 'ToDo' },
            { id: 10, description: 'All Requests of your Donors', abbreviation: 'ReqDon' },
            { id: 20, description: 'All Requests of your Patients', abbreviation: 'ReqPat' },
            { id: 30, description: 'Closed', abbreviation: 'Cld' }
        ],
        centerList: [],
        serologyStatus: -1,
        serologyType: -1,
        filterCenterBy: FilterCenterBy.RecipientCenter,
        filterCenterId: 0,
        filters: {
            centerId: this.props.centerId,
            dateStatus: 0,
            serologyStatus: 0,
            filterStartDate: '',
            filterEndDate: ''
        },
        remoteShipped: {
            show: false,
            data: null
        },
        shippedBack: {
            show: false,
            data: null
        },
        details: {
            show: false,
            data: null
        },
        viewSidePanel: {
            show: false,
            data: null
        },
    };

    container: HTMLDivElement;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        let parsed = qs.parse(location.search);

        let { dateStatus, serologyStatus, filterStartDate, filterEndDate } = this.state.filters;

        if (parsed.dateStatus) {

            dateStatus = parsed.dateStatus;
        }
        if (parsed.serologyStatus) {

            serologyStatus = parsed.serologyStatus;
        }
        if (parsed.filterStartDate) {
            filterStartDate = parsed.filterStartDate;
        }

        if (parsed.filterEndDate) {
            filterEndDate = parsed.filterEndDate;
        }

        let filters: ISerologySearchRequest = {
            centerId: this.props.centerId,
            dateStatus: dateStatus,
            serologyStatus: serologyStatus,
            filterStartDate: filterStartDate,
            filterEndDate: filterEndDate
        };

        this.getData(filters);
    };

    getData = (defaultSearchRequest: ISerologySearchRequest) => {
        this.props.showLoading('Getting Serology requests, one moment please...').then(() => {
            Promise.all([
                this.props.getByCenter(this.props.centerId, defaultSearchRequest),
                this.props.getLookupData()
            ])
                .then(([response, lookUpResponse]) => {
                    if (response.data.success && lookUpResponse.data.success) {
                        let list = response.data.results;
                        let lookUp = lookUpResponse.data.results;

                        this.setState({
                            list,
                            centerList: lookUp.centerList,
                            listType: defaultSearchRequest.serologyStatus
                        }, () => {
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                });
        });
    };

    handleSerologyTrackingDetails = (trackingId: number) => {
        this.props.showLoading('Getting Serology Tracking Details, one moment please...').then(() => {
            this.props.getSerologyTrackingDetails(trackingId).then(response => {
                if (response.data.success) {
                    this.setState({
                        details: {
                            show: true,
                            data: response.data.results
                        }
                    });
                }
                this.props.hideLoading();
            });
        });
    }

    handleCancelDetails = () => {
        this.setState({
            details: {
                show: false,
                data: null
            }
        });
    }

    getCenters = () => {
        let recipientCenters = _.sortBy(
            _.uniqBy(this.state.list.map(x => {
                return {
                    id: x.recipientCenterId,
                    alias: x.recipientCenter,
                    isRecipientCenter: true
                };
            }), item => item.id), item => item.alias);

        let donorCenters = _.sortBy(
            _.uniqBy(this.state.list.map(x => {
                return {
                    id: x.donorCenterId,
                    alias: x.donorCenter,
                    isRecipientCenter: false
                };
            }), item => item.id), item => item.alias);

        let allCenters = [...recipientCenters, ...donorCenters];

        return allCenters;
    }

    handleFilterCenterByChange = (filterCenterBy: FilterCenterBy) => {
        this.setState({
            filterCenterBy
        });
    }

    handleCenterChange = (filterCenterId: number) => {
        this.setState({
            filterCenterId
        });
    }

    handleTypeChange = (listType: number) => {
        let filters: ISerologySearchRequest = {
            centerId: 0,
            dateStatus: 0,
            serologyStatus: listType,
            filterStartDate: '',
            filterEndDate: ''
        };

        this.getData(filters)
    }

    handleAction = (data: ISerologyTracking, eventKey: number) => {
        if (eventKey == Actions.MarkReceived) {
            this.handleMarkReceived(data.id);
        }

        if (eventKey == Actions.MarkRemoteShipped) {
            this.setState({
                remoteShipped: {
                    show: true,
                    data
                }
            })
        }

        if (eventKey == Actions.MarkShippedBack) {
            this.setState({
                shippedBack: {
                    show: true,
                    data
                }
            })
        }

        if (eventKey == Actions.TrackPackage) {
            window.open('http://www.packagetrackr.com/track/' + data.remoteSendTrackingNumber, '_blank');
        }
    }

    closeSidePanelNotifyAndRefresh = () => {
        this.setState({
            viewSidePanel: {
                show: false,
                data: null
            }
        }, () => {
            toast.success('Serology Request Updated Successfully');
            this.getData(this.state.filters)
        });
    }

    handleMarkReceived = (id: number) => {
        this.props.showLoading('Updating the selected request, one moment please...').then(async () => {
            let response = await this.props.markReceived(id, this.props.centerId);

            if (response.data.success) {
                let list = _.cloneDeep(this.state.list).map(x => {
                    if (x.id == id) {
                        return { ...response.data.results, newDeadline: '' };
                    }

                    return x;
                });

                let data = list.find(x => x.id == id);

                this.setState({
                    list,
                    viewSidePanel: { ...this.state.viewSidePanel, data }
                }, () => {
                    toast.success('Serology Request Updated Successfully');
                });
            }

            this.props.hideLoading();
        });
    }

    handleSubmitRemoteShipped = (trackingNumber: string, shippedDateTime: string) => {
        let id = this.state.remoteShipped.data.id;

        this.setState({
            remoteShipped: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(async () => {
                let response = await this.props.markRemoteShipped(id, this.props.centerId, trackingNumber, shippedDateTime);

                if (response.data.success) {
                    let list = _.cloneDeep(this.state.list).map(x => {
                        if (x.id == id) {
                            return { ...response.data.results, newDeadline: '' };
                        }

                        return x;
                    });

                    let data = list.find(x => x.id == id);

                    this.setState({
                        list,
                        viewSidePanel: { ...this.state.viewSidePanel, data }
                    }, () => {
                        toast.success('Serology Request Updated Successfully');
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleCancelRemoteShipped = () => {
        this.setState({
            remoteShipped: {
                show: false,
                data: null
            }
        });
    }

    handleSubmitShippedBack = (trackingNumber: string, shippedDateTime: string) => {
        let id = this.state.shippedBack.data.id;

        this.setState({
            shippedBack: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(async () => {
                let response = await this.props.markShippedBack(id, this.props.centerId, trackingNumber, shippedDateTime);

                if (response.data.success) {
                    let list = _.cloneDeep(this.state.list).map(x => {
                        if (x.id == id) {
                            return { ...response.data.results, newDeadline: '' };
                        }

                        return x;
                    });

                    let data = list.find(x => x.id == id);

                    this.setState({
                        list,
                        viewSidePanel: { ...this.state.viewSidePanel, data }
                    }, () => {
                        toast.success('Serology Request Updated Successfully');
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleCancelShippedBack = () => {
        this.setState({
            shippedBack: {
                show: false,
                data: null
            }
        });
    }

    handleUpdateDeadline = (id: number, deadline: string) => {
        this.props.showLoading('Updating deadline, one moment please...').then(async () => {
            let response = await this.props.updateDeadline(id, deadline);

            if (response.data.success) {
                let list = _.cloneDeep(this.state.list).map(x => {
                    if (x.id == id) {
                        x.statusDeadline = deadline;
                    }

                    return x;
                });
                this.setState({
                    list
                }, () => {
                    toast.success('Message Sent');
                });
            }

            this.props.hideLoading();
        });
    }

    handleSavePanel = async (data: ISerologyTracking) => {
        setTimeout(() => {
            this.handleUpdateDeadline(data.id, data.statusDeadline)
        });
    }

    handleDataChange = (data: ISerologyTracking) => {
        this.setState({
            viewSidePanel: { ...this.state.viewSidePanel, data }
        });
    }

    handleCancelView = () => {
        this.setState({
            viewSidePanel: {
                show: false,
                data: null
            }
        });
    }

    handleViewSerology = (id: number) => {
        let serologyData = _.cloneDeep(this.state.list).find(x => x.donorId == id);

        let data: ISerologyTracking = {
            ...serologyData
        };

        this.setState({
            viewSidePanel: {
                show: true,
                data
            }
        });
    }

    handleFilterChange = (field: string, value: any) => {
        let filters = _.cloneDeep(this.state.filters);

        filters[field] = value;

        this.setState({ filters });
    }

    handleClearGrid = () => {
        this.setState({
            list: [],
            filters: {
                centerId: this.props.centerId,
                dateStatus: 0,
                serologyStatus: 0,
                filterStartDate: '',
                filterEndDate: ''
            },
        })
    }

    handleSearch = () => {
        let { centerId, dateStatus, serologyStatus, filterStartDate, filterEndDate } = this.state.filters;

        let filterRequest: ISerologySearchRequest = {
            centerId: centerId,
            dateStatus,
            serologyStatus,
            filterStartDate,
            filterEndDate
        };

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.getByCenter(centerId, filterRequest).then(response => {
                if (response.data.success) {
                    let results = response.data.results;

                    this.setState({
                        list: results,
                    }, () => {
                        this.setConversionUrl();
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    setConversionUrl = () => {
        let { centerId, dateStatus, serologyStatus, filterStartDate, filterEndDate } = this.state.filters;

        let paramList = [];

        if (filterStartDate != '') {
            paramList.push(encodeURI('filterStartDate=' + filterStartDate));
        }

        if (filterEndDate != '') {
            paramList.push(encodeURI('filterEndDate=' + filterEndDate));
        }

        if (serologyStatus != null) {
            paramList.push(encodeURI('serologyStatus=' + serologyStatus));
        }

        if (dateStatus != null) {
            paramList.push(encodeURI('dateStatus=' + dateStatus));
        }

        let params = paramList.join('&');

        let newUrl = this.props.isAdmin == false ?
            '/center/' + centerId + '/action-center/serology-tracking/by-your-center?' + params
            :
            '/admin/serology-tracking?' + params
            ;

        window.history.pushState({}, '', newUrl);
    }

    render = () => {
        const list = this.state.list;

        let showMarkedReceived = this.state.viewSidePanel.data != null ? this.state.viewSidePanel.data.showMarkedReceived : false;
        let showShippedToRemoteDonor = this.state.viewSidePanel.data != null ? this.state.viewSidePanel.data.showShippedToRemoteDonor : false;
        let showSerologyTestsShippedBack = this.state.viewSidePanel.data != null ? this.state.viewSidePanel.data.showSerologyTestsShippedBack : false;
        let showSerologyTracking = this.state.viewSidePanel.data != null ? this.state.viewSidePanel.data.showSerologyTracking : false;
        let showActionButton = showMarkedReceived || showShippedToRemoteDonor || showSerologyTestsShippedBack || showSerologyTracking;

        return (
            <>
                <MediaQuery minWidth={1023}>
                    <div ref={this.saveContainer} />

                    <div style={{ padding: '0px 10px 10px' }}>
                        <Filters
                            centerId={this.props.centerId}
                            data={this.state.filters}
                            statusList={this.state.statusList}
                            centerList={this.state.centerList}
                            listType={this.state.listType}
                            onChange={this.handleFilterChange}
                            onChangeType={this.handleTypeChange}
                            onClearGrid={this.handleClearGrid}
                            onSearch={this.handleSearch}
                        />

                        <Grid
                            data={list}
                            centerId={this.props.centerId}
                            listType={this.state.listType}
                            isAdmin={false}
                            onAction={this.handleAction}
                            onSerologyTrackingDetails={this.handleSerologyTrackingDetails}
                            onView={this.handleViewSerology}
                            onUpdateDeadline={this.handleUpdateDeadline}
                        />
                    </div>

                    <Drawer
                        width="32vw"
                        placement="right"
                        getContainer={this.getContainer}
                        open={this.state.viewSidePanel.show}
                    >
                        <div style={{ height: '100%', width: '99.7%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ padding: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                    <div style={{ width: '38%' }}>
                                        <h3 style={{ margin: 0 }}>Serology Details</h3>
                                    </div>
                                    {showActionButton && (
                                        <div style={{ width: '33%' }}>
                                            <ActionsDropdown
                                                centerId={this.state.viewSidePanel.data != null ? this.state.viewSidePanel.data.donorCenterId : 0}
                                                data={this.state.viewSidePanel.data}
                                                listType={this.state.listType}
                                                showBsMenu={true}
                                                showActions={true}
                                                onMenuToggle={() => null}
                                                onItemSelected={this.handleAction}
                                            />
                                        </div>
                                    )}

                                    <div style={{ width: '5%', textAlign: 'right' }}>
                                        <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                                    </div>
                                </div>

                                <View
                                    centerId={this.props.centerId}
                                    data={this.state.viewSidePanel.data}
                                    listType={this.state.listType}
                                    onSavePanel={this.handleSavePanel}
                                    onDataChange={this.handleDataChange}
                                />
                            </div>

                            <div className='text-center bg-info'>
                                <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                            </div>
                        </div>
                    </Drawer>
                </MediaQuery>

                <MarkShippedOut
                    show={this.state.remoteShipped.show}
                    data={this.state.remoteShipped.data}
                    title={'Mark Remote Shipped'}
                    isPanel={false}
                    onSubmit={this.handleSubmitRemoteShipped}
                    onCancel={this.handleCancelRemoteShipped}
                />

                <MarkShippedBack
                    show={this.state.shippedBack.show}
                    data={this.state.shippedBack.data}
                    onSubmit={this.handleSubmitShippedBack}
                    onCancel={this.handleCancelShippedBack}
                />
            </>
        );
    }

}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(SerologyTrackingActionCreators.getSerologyLookupData());
        },
        getByCenter: (centerId, serologyFilter) => {
            return dispatch(SerologyTrackingActionCreators.getByCenter(centerId, serologyFilter));
        },
        markReceived: (id, centerId) => {
            return dispatch(SerologyTrackingActionCreators.markReceived(id, centerId));
        },
        markRemoteShipped: (id, centerId, trackingNumber, shippedDateTime) => {
            return dispatch(SerologyTrackingActionCreators.markRemoteShipped(id, centerId, trackingNumber, shippedDateTime));
        },
        markShippedBack: (id, centerId, trackingNumber, shippedDateTime) => {
            return dispatch(SerologyTrackingActionCreators.markShippedBack(id, centerId, trackingNumber, shippedDateTime));
        },
        updateDeadline: (id, deadline) => {
            return dispatch(SerologyTrackingActionCreators.updateDeadline(id, deadline));
        },
        getSerologyTrackingDetails: (trackingId) => {
            return dispatch(SerologyTrackingActionCreators.getById(trackingId));
        }
    };
};

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(SerologyTracking);
